import addMoney from './kid/add-money.webp';
import allowance from './kid/allowance.webp';
import contributeToGoal from './kid/contribute-to-goal.webp';
import createNewSavingsGoal from './kid/create-new-savings-goal.webp';
import doChores from './kid/do-chores.webp';
import giftMoney from './kid/gift-money.webp';
import moneyReceived from './kid/money-received.webp';
import moveBetweenGoals from './kid/move-between-goals.webp';
import withdrawFromSavings from './kid/withdraw-from-savings.webp';
import learningTip from './onboarding/learning-tip.webp';
import parentApproval from './parent/parent-approval.webp';
import balance from './shared/balance.webp';
import family from './shared/family.webp';
import help from './shared/help.webp';
import kidProfile from './shared/kid-profile.webp';
import logOut from './shared/log-out.webp';
import myPiggyBank from './shared/my-piggy-bank.webp';
import mySavings from './shared/my-savings.webp';
import savingsGoal from './shared/savings-goal.webp';
import settings from './shared/settings.webp';
import spentMoney from './shared/spent-money.webp';
import transactionHistory from './shared/transaction-history.webp';
import viewMyReports from './shared/view-my-reports.webp';
import celebrationAchievement from './status/celebration-achievement.webp';
import choreApproved from './status/chore-approved.webp';
import choreNeedsChanges from './status/chore-needs-changes.webp';
import choresSubmittedForApproval from './status/chores-submitted-for-approval.webp';
import choresWaiting from './status/chores-waiting.webp';
import goalCompleted from './status/goal-completed.webp';
import lockedReadOnly from './status/locked-read-only.webp';

export const myPiggyIcons = Object.freeze({
  'add-money': { src: addMoney, alt: 'Add money' },
  allowance: { src: allowance, alt: 'Allowance' },
  balance: { src: balance, alt: 'Current balance' },
  'celebration-achievement': {
    src: celebrationAchievement,
    alt: 'Achievement celebration',
  },
  'chore-approved': { src: choreApproved, alt: 'Chore approved' },
  'chore-needs-changes': {
    src: choreNeedsChanges,
    alt: 'Chore needs changes',
  },
  'chores-submitted-for-approval': {
    src: choresSubmittedForApproval,
    alt: 'Chores submitted for approval',
  },
  'chores-waiting': { src: choresWaiting, alt: 'Chores waiting' },
  'contribute-to-goal': {
    src: contributeToGoal,
    alt: 'Contribute to a savings goal',
  },
  'create-new-savings-goal': {
    src: createNewSavingsGoal,
    alt: 'Create a new savings goal',
  },
  'do-chores': { src: doChores, alt: 'Do chores' },
  family: { src: family, alt: 'Family' },
  'gift-money': { src: giftMoney, alt: 'Gift money' },
  'goal-completed': { src: goalCompleted, alt: 'Savings goal completed' },
  help: { src: help, alt: 'Help' },
  'kid-profile': { src: kidProfile, alt: 'Kid profile' },
  'learning-tip': { src: learningTip, alt: 'Money learning tip' },
  'locked-read-only': { src: lockedReadOnly, alt: 'Read-only access' },
  'log-out': { src: logOut, alt: 'Log out' },
  'money-received': { src: moneyReceived, alt: 'Money received' },
  'move-between-goals': {
    src: moveBetweenGoals,
    alt: 'Move money between goals',
  },
  'my-piggy-bank': { src: myPiggyBank, alt: 'My piggy bank' },
  'my-savings': { src: mySavings, alt: 'My savings' },
  'parent-approval': { src: parentApproval, alt: 'Parent approval' },
  'savings-goal': { src: savingsGoal, alt: 'Savings goal' },
  settings: { src: settings, alt: 'Settings' },
  'spent-money': { src: spentMoney, alt: 'Spent money' },
  'transaction-history': {
    src: transactionHistory,
    alt: 'Transaction history',
  },
  'view-my-reports': { src: viewMyReports, alt: 'View reports' },
  'withdraw-from-savings': {
    src: withdrawFromSavings,
    alt: 'Withdraw from savings',
  },
});

export const MY_PIGGY_ICON_NAMES = Object.freeze(
  Object.keys(myPiggyIcons),
);

